import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import PublicLayout from "./PublicLayout";

export default function LegalDocument({ activePage, title, effectiveDate, lastUpdated, children }) {
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <PublicLayout activePage={activePage}>
            <div className="upload-main">
                <button className="faq-back-btn" onClick={() => navigate(-1)}>
                    <ArrowLeft size={16} />
                    <span>Back</span>
                </button>
                <h1 className="faq-title">{title}</h1>
                {effectiveDate && (
                    <p className="legal-doc-effective">Effective Date: {effectiveDate}</p>
                )}
                <div className="legal-doc">
                    {children}
                </div>
                {lastUpdated && (
                    <p className="legal-doc-updated">Last Updated: {lastUpdated}</p>
                )}
            </div>
        </PublicLayout>
    );
}
